<div class="mat-dialog-container mt-2">
    <div class="header">
        <strong>{{'BUTTONS.MULTI_ASSIGNMENT' | translate}}</strong>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
            (click)="closeDialog()"></button>
    </div>
    <div>
        <!-- Filter Section -->
        <div class="p-3 border-bottom">
            <div class="row g-3">
                <div class="col-md-3">
                    <label class="form-label">{{'FILTERS.SERIAL_NUMBER' | translate}}</label>
                    <ng-select 
                        [(ngModel)]="serialNumberFilter"
                        (ngModelChange)="onFilterChange()"
                        [placeholder]="'FILTERS.SERIAL_NUMBER_PLACEHOLDER' | translate"
                        [clearable]="true"
                        [searchable]="true"
                        bindLabel="serialNumber"
                        bindValue="serialNumber"
                        >
                        <ng-option *ngFor="let device of devices" [value]="device.serialNumber">
                            {{device.serialNumber}}
                        </ng-option>
                    </ng-select>
                </div>
                <div class="col-md-3 date-input">
                    <label class="form-label">{{'FILTERS.START_DATE' | translate}}</label>
                    <input 
                        class="input-field" type="date"
                        [(ngModel)]="startDateFilter"
                        (change)="onFilterChange()">
                </div>
                <div class="col-md-3 date-input">
                    <label class="form-label">{{'FILTERS.END_DATE' | translate}}</label>
                    <input 
                        class="input-field" type="date"
                        [(ngModel)]="endDateFilter"
                        (change)="onFilterChange()">
                </div>
                <div class="col-md-3">
                    <label class="form-label">{{'VIBRATION.NOTE' | translate}}</label>
                    <input
                    type="text" class="input-field w-100"
                    [(ngModel)]="noteFilter"
                    (input)="noteSearch$.next(noteFilter)"
                    [placeholder]="'VIBRATION.NOTE' | translate">
                </div>
            </div>
        </div>
        
        <div class="overflow-box" #scrollContainer>
            <div class="d-flex flex-column">
                <div class="d-flex cursor-pointer">
                    <div class="checkbox-container"></div>
                    <div class=" flex-grow-1 col-2" (click)="sortTable('filename')">
                        <strong>{{'FORM.FILE_NAME' | translate}}</strong>
                        <svg-icon [src]="sortOrder ? './icon/chevron-up.svg' : './icon/chevron-down.svg'" [svgStyle]="{
                            width: '16px',
                            height: '16px'            
                        }"></svg-icon>
                    </div>
                    <div class=" flex-grow-1 col-2" (click)="sortTable('date')">
                        <strong>{{'FORM.DATE_AND_TIME' | translate}}</strong>
                        <svg-icon [src]="sortOrder ? './icon/chevron-up.svg' : './icon/chevron-down.svg'" [svgStyle]="{
                            width: '16px',
                            height: '16px'            
                        }"></svg-icon>
                    </div>
                    <div class=" flex-grow-1 col-2">
                        <strong>{{'VIBRATION.NOTE' | translate}}</strong>
                    </div>
                    <div class="flex-grow-1 col-2">
                        <strong>{{'VIBRATION.MAX' | translate}}</strong>
                    </div>
                    <div class="flex-grow-1 col-2">
                        <strong>{{'RECORD.ASSIGNED' | translate}}</strong>
                    </div>
                </div>
                <div>
                    <div *ngFor="let record of allRecords; index as j;" class="border border-2 m-3 p-3 rounded-2">
                        <div class="d-flex align-items-center cursor-pointer">
                            <div class="ps-1" style="padding-right: 1rem;">
                                <input class="custom-checkbox" type="checkbox"
                                    [checked]="selectedRecordIds.includes(record.id)"
                                    (change)="onCheckboxChange(record.id, $event)">
                            </div>
                            <div class="flex-grow-1 col-2 filename-cell">
                                <span class="colored-title filename-text" [title]="record?.recordMetadata.fileName">{{record?.recordMetadata.fileName}}</span>
                            </div>
                            <div class="flex-grow-1 col-2">
                                <div>
                                    <span>{{record?.recordMetadata.timestamp | date: 'dd/MM/yyyy':'UTC'}}</span>
                                </div>
                                <div>
                                    <span>
                                        {{record?.recordMetadata.timestamp | date: 'HH:mm:ss':'UTC'}}
                                    </span>
                                </div>
                            </div>
                            <div class="flex-grow-1 col-2">
                                <div>
                                    <span>{{record?.recordMetadata.note1}}</span>
                                </div>
                                <div>
                                    <span>{{record?.recordMetadata.note2}}</span>
                                </div>
                                <div>
                                    <span>{{record?.recordMetadata.note3}}</span>
                                </div>
                            </div>
                            <div class="col-3">
                                <div>
                                    <span>
                                        V:
                                        {{record?.recordMetadata.verticalPpv | number : '1.2-2'}}
                                    </span>
                                    <span class="ms-2">
                                        L:
                                        {{record?.recordMetadata.longitudinalPpv | number : '1.2-2'}}
                                    </span>
                                </div>
                                <div>
                                    <span>
                                        T:
                                        {{record?.recordMetadata.transversePpv | number : '1.2-2'}}
                                    </span>
                                    <span class="ms-2">
                                        VS: {{record?.recordMetadata.vecSomme | number : '1.2-2'}}
                                    </span>
                                </div>
                            </div>
                            <div class="flex-grow-1 d-flex align-items-center col-2">
                                <div>
                                    <div *ngIf="record?.eventId"><img src="./icon/blastMenu.svg" /> <span class="ms-1">
                                            {{getEvent(record.eventId)?.name}}
                                        </span>
                                    </div>
                                    <div *ngIf="!record?.eventId" class="opacity-50 text-muted">
                                        <div class="row d-flex align-items-center">
                                            <div class="col-auto">
                                                <img src="./icon/question-mark.svg" />
                                            </div>
                                            <div class="col p-0">
                                                <div>{{'EVENT.LABEL' | translate}}</div>
                                                <div>{{'RECORD.UNASSIGNED' | translate}}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div *ngIf="record?.controlPointId"><img src="./icon/control-point-black.svg" />
                                        <span class="ms-1">
                                            {{getControlPointName(record?.controlPointId)}}
                                        </span>
                                    </div>
                                    <div *ngIf="!record?.controlPointId" class="opacity-50 text-muted">
                                        <div class="row d-flex align-items-center">
                                            <div class="col-auto">
                                                <img src="./icon/question-mark.svg" />
                                            </div>
                                            <div class="col p-0">
                                                <div>{{'NAVIGATION.MEASUREMENT_POINT' | translate}}</div>
                                                <div>{{'RECORD.UNASSIGNED' | translate}}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div><img src="./icon/device.svg" /><span class="ms-1">
                                            {{record?.recordMetadata.seismographName ??
                                            record?.recordMetadata.seismographSerialNumber}}

                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="d-flex justify-content-between align-items-start mb-1">
            <div class="mb-1 me-3" style="flex: 1;">
                <strong class="form-label text-center d-block">
                    {{ 'DEVICE.SITE' | translate }}
                </strong>
                <ng-select
                    [items]="allSites"
                    bindLabel="nom"
                    bindValue="siteId"
                    [(ngModel)]="selectedSiteId"
                    [clearable]="true"
                    (ngModelChange)="onSiteChange($event)">
                </ng-select>
            </div>
            <div class="mb-1 me-3" style="flex: 1;">
                <strong class="form-label text-center d-block" for="controlPointId">
                    {{ 'RECORD.CONTROL_POINT' | translate }}
                </strong>
                <ng-select [items]="controlPoints" bindLabel="name" bindValue="controlPointId"
                    [(ngModel)]="selectedControlPointId" [clearable]="true">
                </ng-select>
            </div>
            <div class="mb-1" style="flex: 1;">
                <strong class="form-label text-center d-block" for="companyName">
                    {{ 'RECORD.EVENT' | translate }}
                </strong>
                <ng-select [items]="events" bindLabel="name" bindValue="id" [(ngModel)]="selectedEventId" id="id">
                </ng-select>
            </div>
        </div>
            <div *ngIf="errorMessage !== ''" class="error-message-container">
        <div class="error-message">
          <i class="fas fa-exclamation-triangle"></i>
          <span>{{ errorMessage }}</span>
          <button type="button" class="error-close-btn" (click)="closeErrorMessage()" title="Fermer">
            <i class="fas fa-times"></i>
          </button>
        </div>
      </div>
        <div class="button-group p-2">
            <button class="secondary-button popup-secondary-button" (click)="closeDialog()">{{'BUTTONS.CANCEL' | translate}}</button>
            <button class="primary-button popup-primary-button" (click)="confirm()">{{'BUTTONS.CONFIRM' | translate}}</button>
        </div>
    </div>
</div>